// pages/CampaignsPage.tsx
import { useState } from "react";
import { Search, Plus, Eye, Edit, Trash2, Send } from "lucide-react";
import PageListLayout from "../../../layouts/PageListLayout";
import MenuModal, { Menu } from "../../../components/ui/MenuModal";
import { useNavigate } from "react-router-dom";

export default function CampaignsPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCampaign, setSelectedCampaign] = useState<any | null>(null);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [campaignToUpdate, setCampaignToUpdate] = useState<any | null>(null);

  const displayCampaigns = searchQuery.trim() ? [] : [];

  const handleSearch = async () => {};

  const handleCreateCampaign = async (campaignData: any) => {};

  const handleUpdateCampaign = async (campaignData: any) => {};

  const handleDeleteCampaign = async (campaignId: string) => {};

  const getActionsMenu = (campaign: any): Menu[] => {
    return [
      {
        label: "Voir détails",
        icon: Eye,
        onClick: () => {
          navigate("/marketing/campaigns/details", { state: campaign });
          setSelectedCampaign(null);
        },
      },
      {
        label: "Modifier",
        icon: Edit,
        onClick: () => {
          setCampaignToUpdate(campaign);
          setUpdateModalOpen(true);
          setSelectedCampaign(null);
        },
      },
      {
        label: "Lancer",
        icon: Send,
        onClick: () => {
          setSelectedCampaign(null);
        },
      },
      {
        label: "Supprimer",
        icon: Trash2,
        onClick: () => {
          handleDeleteCampaign(campaign.id);
          setSelectedCampaign(null);
        },
      },
    ];
  };

  const isAnySubModalOpen = detailsModalOpen || updateModalOpen || createModalOpen;

  return (
    <PageListLayout title="">
      <div className="px-6 py-5 bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-2xl font-bold text-[#031B4E] tracking-tight">Campagnes</h1>
              <p className="text-sm text-slate-400 font-light mt-0.5">
                Gérez vos campagnes marketing et suivez leurs performances.
              </p>
            </div>
            <button
              onClick={() => setCreateModalOpen(true)}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2"
            >
              <Plus size={18} />
              <span>Nouvelle campagne</span>
            </button>
          </div>
          <div className="mt-6">
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1">
                <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="text"
                  placeholder="Rechercher par nom, type ou statut..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                  className="w-full pl-10 pr-4 py-2.5 bg-slate-50/50 border border-slate-200 rounded-xl text-sm text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:bg-white focus:outline-none focus:ring-4 focus:ring-blue-600/5 transition-all"
                />
              </div>
              <button
                onClick={handleSearch}
                className="px-5 py-2.5 bg-primary text-white font-medium text-sm rounded-xl hover:bg-primary/90 focus:outline-none focus:ring-4 focus:ring-primary/10 transition-all shadow-sm"
              >
                Rechercher
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6 py-8 max-w-7xl mx-auto">
        {/* Liste des campagnes */}
      </div>
      {selectedCampaign && !isAnySubModalOpen && (
        <MenuModal
          title={selectedCampaign.name || "Actions campagne"}
          isOpen={true}
          onClose={() => setSelectedCampaign(null)}
          icon={null}
          menu={getActionsMenu(selectedCampaign)}
        />
      )}
    </PageListLayout>
  );
}